import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import { Box } from "../Box/index.js";
import { Icon } from "../Icon/index.js";
import { Tooltip } from "../Tooltip/index.js";
import { Typography } from "../Typography/index.js";
import { useStyles } from "./GroupAvatar.styles.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const GroupAvatar = (t0)=>{
    const $ = c(28);
    const { children, loadImage, size: t1, borderSize, borderColor } = t0;
    const size = void 0 === t1 ? "medium" : t1;
    const { classes } = useStyles();
    const [src, setSrc] = useState();
    const [hasError, setHasError] = useState(false);
    const handleAvatarIconSize = _temp;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setHasError(true);
        $[0] = t2;
    } else t2 = $[0];
    const handleSetError = t2;
    let t3;
    let t4;
    if ($[1] !== loadImage) {
        t3 = ()=>{
            const fetchImage = ()=>_async_to_generator(function*() {
                    try {
                        setSrc((yield loadImage()));
                    } catch (t5) {
                        setHasError(true);
                    }
                })();
            fetchImage();
        };
        t4 = [
            loadImage
        ];
        $[1] = loadImage;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    useEffect(t3, t4);
    if (hasError) {
        const t5 = classes[size];
        let t6;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = /*#__PURE__*/ jsxs(Box, {
                display: "flex",
                flexDirection: "column",
                gap: "8",
                children: [
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "caption",
                        color: "bg.light.primary",
                        children: "Не удалось загрузить изображение"
                    }),
                    /*#__PURE__*/ jsx(Typography, {
                        variant: "caption",
                        color: "text.dark.secondary",
                        children: "Попробуйте обновить страницу"
                    })
                ]
            });
            $[4] = t6;
        } else t6 = $[4];
        const t7 = handleAvatarIconSize(size);
        let t8;
        if ($[5] !== t7) {
            t8 = /*#__PURE__*/ jsx(Tooltip, {
                placement: "top",
                title: t6,
                children: /*#__PURE__*/ jsx(Icon, {
                    size: t7,
                    color: "stroke.secondary",
                    name: "picture_slash_outline"
                })
            });
            $[5] = t7;
            $[6] = t8;
        } else t8 = $[6];
        let t9;
        if ($[7] !== borderColor || $[8] !== borderSize || $[9] !== children || $[10] !== t5 || $[11] !== t8) {
            t9 = /*#__PURE__*/ jsxs(Box, {
                className: t5,
                radius: "round",
                position: "relative",
                bgcolor: "bg.greyscale.primary",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexShrink: 0,
                border: borderSize,
                borderColor: borderColor,
                children: [
                    children,
                    t8
                ]
            });
            $[7] = borderColor;
            $[8] = borderSize;
            $[9] = children;
            $[10] = t5;
            $[11] = t8;
            $[12] = t9;
        } else t9 = $[12];
        return t9;
    }
    if (!src) {
        const t5 = classes[size];
        const t6 = handleAvatarIconSize(size);
        let t7;
        if ($[13] !== t6) {
            t7 = /*#__PURE__*/ jsx(Icon, {
                size: t6,
                color: "stroke.secondary",
                name: "users_3_outline"
            });
            $[13] = t6;
            $[14] = t7;
        } else t7 = $[14];
        let t8;
        if ($[15] !== borderColor || $[16] !== borderSize || $[17] !== children || $[18] !== t5 || $[19] !== t7) {
            t8 = /*#__PURE__*/ jsxs(Box, {
                className: t5,
                radius: "round",
                position: "relative",
                bgcolor: "bg.greyscale.secondary",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexShrink: 0,
                border: borderSize,
                borderColor: borderColor,
                children: [
                    children,
                    t7
                ]
            });
            $[15] = borderColor;
            $[16] = borderSize;
            $[17] = children;
            $[18] = t5;
            $[19] = t7;
            $[20] = t8;
        } else t8 = $[20];
        return t8;
    }
    const t5 = classes[size];
    let t6;
    if ($[21] !== classes.image || $[22] !== src) {
        t6 = /*#__PURE__*/ jsx("img", {
            src: src,
            alt: "avatar",
            className: classes.image,
            onError: handleSetError
        });
        $[21] = classes.image;
        $[22] = src;
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== children || $[25] !== t5 || $[26] !== t6) {
        t7 = /*#__PURE__*/ jsxs(Box, {
            className: t5,
            radius: "round",
            position: "relative",
            bgcolor: "bg.greyscale.primary",
            flexShrink: 0,
            children: [
                children,
                t6
            ]
        });
        $[24] = children;
        $[25] = t5;
        $[26] = t6;
        $[27] = t7;
    } else t7 = $[27];
    return t7;
};
function _temp(variant) {
    switch(variant){
        case "large":
            return "48";
        case "medium":
            return "28";
        case "small":
            return "20";
        default:
            return "16";
    }
}
export { GroupAvatar };
